/**
 * Route constants — single source of truth for all route paths.
 */
export const ROUTES = {
  LOGIN: '/login',
  SIGNUP: '/signup',
  RECOVER: '/recover',
  HOME: '/',
  GROUPS: '/groups',
  GROUP_DETAIL: '/groups/:id',
  MATERIALS: '/materials',
  MY_COURSES: '/my-courses',
  MARKET: '/market',
  COURSE_DETAIL: '/market/:id',
  SLIDE_VIEWER: '/slides/:id',
  TRAINERS: '/trainers',
  EXERCISES_LIST: '/exercises',
  EXERCISES: '/exercises/:id',
  DIALOGS_LIST: '/dialogs',
  HOMEWORK: '/homework',
  VOCABULARY: '/vocabulary',
  PROFILE: '/profile',
  SETTINGS: '/settings',
  SCHEDULE: '/schedule',
  ADMIN: '/admin',
  ADMIN_USERS: '/admin/users',
  ADMIN_TEACHERS: '/admin/teachers',
  ADMIN_TEACHER_DETAIL: '/admin/teachers/:id',
  ADMIN_STUDENTS: '/admin/students',
  ADMIN_STATS_GROUPS: '/admin/stats-groups',
  ADMIN_TRAINERS: '/admin/trainers',
  ADMIN_TRAINERS_MODERATION: '/admin/trainers-moderation',
  ADMIN_MATERIALS: '/admin/materials',
  ADMIN_PAYMENTS: '/admin/payments',
  ADMIN_PLATFORM_SETTINGS: '/admin/platform-settings',
  ADMIN_TAGS: '/admin/tags',
  ADMIN_TTS: '/admin/tts',
  ADMIN_MARKET: '/admin/market',
  ADMIN_PRICING: '/admin/pricing',
  ADMIN_CERTIFICATES: '/admin/certificates',
  ADMIN_BUG_REPORTS: '/admin/bug-reports',
  TESTS_LIST: '/tests',
  TRAINERS_QUESTIONNAIRE: '/trainers/questionnaire',
  TRAINERS_CARDS_TEST: '/trainers/cards/test',
  TRAINERS_TREADMILLS: '/trainers/treadmills',
  SHARED_STATS: '/shared/stats/:token',
  ONLINE_LESSON: '/groups/:id/online',
  POSTS: '/posts',
  WALLET: '/wallet',
  NOTIFICATIONS: '/notifications',
  SONGS: '/songs',
  SONG_DETAIL: '/songs/:id',
  SONG_ALBUM_DETAIL: '/songs/albums/:id',
  ADMIN_SONGS: '/admin/songs',
} as const;
